import { api } from './api';

const RecipeService = {
  getListRecipes: (params: any) => {
    return api.authGet(`/auth/owner/recipe`, params);
  },

  createRecipe: (params: any) => {
    return api.authPostForm('/auth/owner/recipe', params);
  },

  updateRecipe: (recipe_id: string, params: any) => {
    return api.authPutForm(`/auth/owner/recipe/${recipe_id}`, params);
  },

  getRecipeDetail: (recipe_id: any) => {
    return api.authGet(`/auth/owner/recipe/${recipe_id}`);
  },

  createInstruction: (recipe_id: string, params: any) => {
    return api.authPostForm(
      `/auth/owner/recipe/${recipe_id}/instruction`,
      params
    );
  },

  updateInstruction: (
    recipe_id: string,
    instruction_id: string,
    params: any
  ) => {
    return api.authPutForm(
      `/auth/owner/recipe/${recipe_id}/instruction/${instruction_id}`,
      params
    );
  },

  orderInstruction: (recipe_id: string, params: any) => {
    return api.authPut(
      `/auth/owner/recipe/${recipe_id}/instruction/order`,
      params
    );
  },

  deleteInstruction: (recipe_id: string, instruction_id: string) => {
    return api.authDelete(
      `/auth/owner/recipe/${recipe_id}/instruction/${instruction_id}`
    );
  },

  createIngredient: (recipe_id: string, params: any) => {
    return api.authPostForm(
      `auth/owner/recipe/${recipe_id}/ingredient`,
      params
    );
  },

  updateIngredient: (recipe_id: string, ingredient_id: string, params: any) => {
    return api.authPutForm(
      `/auth/owner/recipe/${recipe_id}/ingredient/${ingredient_id}`,
      params
    );
  },

  orderIngredient: (recipe_id: string, params: any) => {
    return api.authPut(
      `/auth/owner/recipe/${recipe_id}/ingredient/order`,
      params
    );
  },

  deleteIngredient: (recipe_id: string, ingredient_id: string) => {
    return api.authDelete(
      `/auth/owner/recipe/${recipe_id}/ingredient/${ingredient_id}`
    );
  },

  deleteRecipe: (id?: any) => {
    return api.authDelete(`auth/owner/recipe/${id}`);
  },

  deleteImageRecipe: (id?: any) => {
    return api.authPut(`auth/owner/recipe/${id}/delete-image`)
  },
};

export default RecipeService;
